export default "__VITE_ASSET__CLcHDAUt__"